/* ==========================================================================
   mate CRO v2 — cart drawer enhancements (data: snippets/pdp-cart-enhance.liquid)

   Runs after every drawer rebuild: theme.CartDrawer.buildCart() re-renders
   #CartContainer from the Handlebars template, then fires
   'updateCart.ajaxcart' with the cart JSON. Nothing here replaces the theme's
   add / remove / gift / tier logic:
   - Upgrading a line posts /cart/change.js with the line key + selling_plan,
     then fires 'added.ajaxProduct' so the theme rebuilds the drawer itself.
   - Recommendation buttons carry the theme's .btn-AddToCart class inside
     their own small form, so the global handler in layout/theme.liquid adds
     them and runs the free-gift / tier logic exactly as before.
   ========================================================================== */
(function ($) {
  'use strict';
  if (!$) return;

  var dataEl = document.getElementById('PdpCartCatalog');
  if (!dataEl) return;
  var catalog;
  try { catalog = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var byVariant = {}, byHandle = {};
  catalog.products.forEach(function (p) {
    byHandle[p.handle] = p;
    Object.keys(p.variants).forEach(function (id) {
      byVariant[id] = $.extend({ handle: p.handle }, p.variants[id]);
    });
  });

  // Variant id of a line that was just switched to a subscription, so the tier
  // chips animate in on the rebuild that follows instead of appearing abruptly.
  var revealFor = null;

  /* Copy. English is the default; on the Spanish storefront (/es/) the catalog
     carries an "i18n" object from pdp-cart-enhance.liquid that overrides it. */
  var T = $.extend({
    subscribed: 'Subscribed!', saving: 'Saving {pct}%', skip: 'Skip or cancel anytime',
    upgrade: 'Upgrade to Subscription', save: 'Save {pct}%', insteadOf: 'instead of',
    cadence: { 1: '1 jar delivered monthly', 2: '2 jars delivered every 2 months', 3: '3 jars delivered every 3 months' },
    per: { 1: '/mo', 2: ' every 2 mo', 3: ' every 3 mo' },
    tiersHead: '<b>Save even more.</b> Get 3 months for best results', tiersCheaper: ' &mdash; at a lower monthly price',
    chipTop: '{n} jars every {n} months', mo: '/mo', today: '{price} today', best: 'Best value',
    recsTitle: 'Complete your routine', subSave: 'Subscribe &amp; save {pct}%', addLabel: 'Add {title} to cart'
  }, catalog.i18n || {});
  function f(str, map) { return String(str).replace(/\{(\w+)\}/g, function (m, k) { return k in map ? map[k] : m; }); }
  var CADENCE = T.cadence;
  var PER = T.per;

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return '$' + (cents / 100).toFixed(2);
  }
  function moneyShort(cents) { return money(cents).replace(/\.00$/, ''); }
  function pct(price, planPrice) { return Math.round((price - planPrice) * 100 / price); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- 1. Upgrade to Subscription on each line ---------- */
  function enhanceLines(cart) {
    var rows = document.querySelectorAll('#CartContainer .ajaxcart__product');
    cart.items.forEach(function (item, i) {
      var row = rows[i];
      var info = byVariant[item.variant_id];
      if (!row || !info || !info.plan) return;

      var subscribed = !!item.selling_plan_allocation;
      var qty = info.qty;
      var off = pct(info.price, info.planPrice);
      var box = document.createElement('label');
      box.className = 'pdpcu' + (subscribed ? ' pdpcu--on' : '');
      box.innerHTML =
        '<input type="checkbox" class="pdpcu__input" form="pdpcu-none"' + (subscribed ? ' checked' : '') + '>' +
        '<span class="pdpcu__box" aria-hidden="true"></span>' +
        '<span class="pdpcu__text">' +
          (subscribed
            ? '<span class="pdpcu__head"><b>' + T.subscribed + '</b> <span class="pdpcu__save">' + f(T.saving, { pct: off }) + '</span></span>' +
              '<span class="pdpcu__sub">' + CADENCE[qty] + ' &middot; ' + T.skip + '</span>'
            : '<span class="pdpcu__head"><b>' + T.upgrade + '</b> <span class="pdpcu__save">' + f(T.save, { pct: off }) + '</span></span>' +
              '<span class="pdpcu__sub">' + money(info.planPrice) + PER[qty] + ' ' + T.insteadOf + ' ' + money(info.price) + ' &middot; ' + T.skip + '</span>') +
        '</span>';

      // The chips are buttons, so they must sit OUTSIDE the <label> — inside it
      // every click would also toggle the subscribe checkbox.
      var group = document.createElement('div');
      group.className = 'pdpcu-group';
      var anchor = row.querySelector('.ajaxcart__product-name--wrapper');
      if (!anchor) return;
      anchor.parentNode.insertBefore(group, anchor.nextSibling);
      group.appendChild(box);
      if (subscribed && item.quantity === 1) renderTiers(group, item, info);

      // Show what the subscriber saves against the one-time price.
      if (subscribed && item.price < info.price) {
        var priceEl = row.querySelector('.ajaxcart__price');
        if (priceEl && !row.querySelector('.pdpcu__was')) {
          var was = document.createElement('s');
          was.className = 'pdpcu__was';
          was.textContent = money(info.price);
          // Inside the price element: theme CSS lifts .ajaxcart__price to the
          // row's top-right (position: fixed), so a sibling would be left behind.
          priceEl.appendChild(was);
        }
      }

      box.querySelector('input').addEventListener('change', function (e) {
        var on = e.target.checked;
        box.classList.add('pdpcu--busy');
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({ id: item.key, quantity: item.quantity, selling_plan: on ? info.plan : null })
        }).then(function () {
          if (on) revealFor = item.variant_id;
          $('body').trigger('added.ajaxProduct');
        }, function () {
          e.target.checked = !on;
          box.classList.remove('pdpcu--busy');
          box.classList.add('pdpcu--error');
        });
      });
    });
  }

  /* ---------- 1b. Bigger plan for a subscribed single-jar line ----------
     Same jars-per-month, fewer deliveries, lower monthly price: 1 jar monthly
     $48/mo -> 2 jars every 2 months $46/mo -> 3 jars every 3 months $43/mo.
     Jar counts are separate variants, so this is an add + remove, not a
     quantity change. Add first: if it fails the original line is untouched. */
  function tierOffers(info) {
    var p = byHandle[info.handle];
    if (!p) return [];
    var out = [];
    Object.keys(p.variants).forEach(function (id) {
      var v = p.variants[id];
      if (v.qty > info.qty && v.qty <= 3 && v.available && v.plan) out.push($.extend({ id: id }, v));
    });
    return out.sort(function (a, b) { return a.qty - b.qty; });
  }

  function renderTiers(group, item, info) {
    var offers = tierOffers(info);
    if (!offers.length) return;

    var now = Math.round(info.planPrice / info.qty);          // what they pay a month today
    var best = offers.reduce(function (a, b) { return Math.round(b.planPrice / b.qty) < Math.round(a.planPrice / a.qty) ? b : a; });
    var bestMo = Math.round(best.planPrice / best.qty);
    var cheaper = bestMo < now;

    var el = document.createElement('div');
    el.className = 'pdpcu__tiers' + (revealFor === item.variant_id ? ' pdpcu__tiers--reveal' : '');
    // "3 months", not "90 days": it matches the language on the variants themselves.
    var html = '<p class="pdpcu__tiers-head">' + T.tiersHead +
      (cheaper ? T.tiersCheaper : '') + '.</p><div class="pdpcu__chips">';
    offers.forEach(function (v) {
      var mo = Math.round(v.planPrice / v.qty);
      html +=
        '<button type="button" class="pdpcu__chip" data-id="' + v.id + '" data-plan="' + v.plan + '">' +
          '<span class="pdpcu__chip-dot" aria-hidden="true"></span>' +
          '<span class="pdpcu__chip-text">' +
            '<span class="pdpcu__chip-top">' + f(T.chipTop, { n: v.qty }) + '</span>' +
            // Old monthly price struck on the left, then the new one. The row is
            // only ~149px of text wide (it sits in the column beside the product
            // image), which the struck price fits only without its own "/mo".
            '<span class="pdpcu__chip-sub">' +
              (mo < now ? '<s class="pdpcu__chip-old">' + moneyShort(now) + '</s> ' : '') +
              '<b>' + moneyShort(mo) + T.mo + '</b>' +
              '<span class="pdpcu__chip-now">&middot; ' + f(T.today, { price: moneyShort(v.planPrice) }) + '</span>' +
            '</span>' +
          '</span>' +
          (v === best && cheaper ? '<span class="pdpcu__chip-badge">' + T.best + '</span>' : '') +
        '</button>';
    });
    el.innerHTML = html + '</div>';
    group.appendChild(el);

    el.querySelectorAll('.pdpcu__chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        // Fill this row's dot straight away: on touch there is no hover, so the
        // tap needs to confirm itself before the swap and rebuild land.
        el.querySelectorAll('.pdpcu__chip').forEach(function (c) { c.classList.toggle('pdpcu__chip--on', c === chip); });
        group.classList.add('pdpcu-group--busy');
        $.ajax({
          type: 'POST', url: '/cart/add.js', contentType: 'application/json', dataType: 'json',
          data: JSON.stringify({ id: Number(chip.getAttribute('data-id')), quantity: 1, selling_plan: Number(chip.getAttribute('data-plan')) })
        }).then(function () {
          // Re-read the cart before removing the old line: when a discount code
          // is applied, the add re-allocates discounts and every line key
          // changes, so item.key is stale and /cart/change.js 400s (leaving
          // the customer with both the old and the new jar).
          return $.getJSON('/cart.js');
        }).then(function (fresh) {
          var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id;
          var old = (fresh.items || []).filter(function (it) {
            return it.variant_id === item.variant_id &&
              (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan.id) === plan;
          })[0];
          if (!old) return null;
          return $.ajax({
            type: 'POST', url: '/cart/change.js', contentType: 'application/json', dataType: 'json',
            data: JSON.stringify({ id: old.key, quantity: 0 })
          });
        }).then(function () {
          $('body').trigger('added.ajaxProduct');
        }, function () {
          chip.classList.remove('pdpcu__chip--on');
          group.classList.remove('pdpcu-group--busy');
          group.classList.add('pdpcu-group--error');
        });
      });
    });
  }

  /* ---------- 2. Complete your routine ---------- */
  function pickRecs(cart) {
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.handle] = true; });
    var blocked = {};
    Object.keys(inCart).forEach(function (h) { if (catalog.conflicts[h]) blocked[catalog.conflicts[h]] = true; });

    var out = [];
    catalog.products.forEach(function (p) {
      if (out.length >= 3 || inCart[p.handle] || blocked[p.handle] || !p.available) return;
      var oneJar = null;
      Object.keys(p.variants).forEach(function (id) {
        var v = p.variants[id];
        if (v.qty === 1 && v.available) oneJar = $.extend({ id: id }, v);
      });
      if (oneJar) out.push({ p: p, v: oneJar });
    });
    return out;
  }

  function renderRecs(cart) {
    var host = document.querySelector('#CartContainer .drawer__scrollable');
    if (!host || cart.item_count === 0) return;
    var recs = pickRecs(cart);
    if (!recs.length) return;

    // Default the toggle to match the cart: a subscriber sees subscription pricing.
    var cartHasSub = cart.items.some(function (it) { return !!it.selling_plan_allocation; });

    var html = '<div class="pdpcr"><p class="pdpcr__title">' + T.recsTitle + '</p>';
    recs.forEach(function (r) {
      var v = r.v, p = r.p;
      var sub = cartHasSub && !!v.plan;
      html +=
        '<form class="pdpcr__item" method="post" action="/cart/add" data-sub="' + (sub ? 1 : 0) + '">' +
          '<input type="hidden" name="id" value="' + v.id + '">' +
          '<input type="hidden" name="quantity" value="1">' +
          (v.plan ? '<input type="hidden" name="selling_plan" value="' + v.plan + '"' + (sub ? '' : ' disabled') + '>' : '') +
          '<a class="pdpcr__img" href="' + esc(p.url) + '"><img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy" width="64" height="64"></a>' +
          '<div class="pdpcr__body">' +
            '<p class="pdpcr__name"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></p>' +
            '<p class="pdpcr__need">' + esc(p.need) + '</p>' +
            (v.plan
              ? '<label class="pdpcr__sub"><input type="checkbox" form="pdpcr-none"' + (sub ? ' checked' : '') + '>' +
                '<span class="pdpcr__box" aria-hidden="true"></span>' + f(T.subSave, { pct: pct(v.price, v.planPrice) }) + '</label>'
              : '') +
          '</div>' +
          '<button type="submit" class="pdpcr__add btn-AddToCart" aria-label="' + f(T.addLabel, { title: esc(p.title) }) + '">' +
            '<span class="pdpcr__plus" aria-hidden="true">+</span>' +
            '<span class="pdpcr__price" data-m="otp">' + money(v.price) + '</span>' +
            (v.plan ? '<span class="pdpcr__price" data-m="sub">' + money(v.planPrice).replace(/\.00$/, '') + '<small>' + T.mo + '</small></span>' : '') +
          '</button>' +
        '</form>';
    });
    html += '</div>';
    $(host).append(html);

    host.querySelectorAll('.pdpcr__sub input').forEach(function (box) {
      box.addEventListener('change', function () {
        var form = box.closest('.pdpcr__item');
        form.setAttribute('data-sub', box.checked ? 1 : 0);
        var plan = form.querySelector('input[name="selling_plan"]');
        if (plan) plan.disabled = !box.checked;
      });
    });
  }

  function enhance(cart) {
    if (!cart || !cart.items) return;
    enhanceLines(cart);
    renderRecs(cart);
    revealFor = null;  // the reveal animation plays once, on the rebuild after subscribing
  }

  $('body').on('updateCart.ajaxcart', function (e, cart) { enhance(cart); });
})(window.jQuery);
